<template>
	<div class="book-content">
		<navBar>{{ title }}</navBar>
		<div class="content-box">
			<div class="loading-box" v-if="isLoading">数据加载中...</div>
			<div class="textBox" v-for="(item, i) in listData" :key="'ind' + i">
				<div class="zhangList df-a df-sb" @click="gettextBox(item, i)">
					<div class="leftBox"><img :src="item.chaptericon" alt="" /></div>
					<div class="zhangInfs df-c df-d">
						<div class="font28 zhangName">{{ item.name }}</div>
						<div class="font22 mCG df-a">
							{{ item.usersection }}/{{ item.section }}
							<div style="width: 1.95rem; margin-left: 0.24rem">
								<van-progress
									:percentage="(item.usersection / item.section) * 100"
									:show-pivot="false"
									color="#FF7A32"
								/>
							</div>
						</div>
					</div>
					<div class="RightBox font20 mCG df-mc df-d" v-if="userInfs.mode == 1">
						<img :src="icon3" alt="" />
						闯关中
					</div>
				</div>
				<div class="contentList" v-show="item.show">
					<div
						class="jieitem font24"
						@click="goPage(list, item.name, i,item.children)"
						v-for="(list, i) in item.children"
						:key="'child' + list.id"
					>
						<div class="zzxue tac mCf" v-if="false">正在学</div>
						<div class="jietitle">第{{ i + 1 }}节</div>
						<div class="font28 title">{{ list.name }}</div>
						<div class="df dianBox">
							<div class="dian guo"></div>
							<div class="dian guo"></div>
							<div class="dian active"></div>
							<div class="dian"></div>
						</div>
						<div class="df-sb">
							<!-- <div class="xuefen mCG">学分：5/88</div> -->
							<div class="df-a miao" v-show="false">
								<img
									style="width: 0.24rem; height: 0.24rem; margin-right: 0.1rem"
									:src="icon4"
									alt=""
								/>
								完成本节共需约1小时
							</div>
						</div>
					</div>
					<!-- <div class="jieitem active font24">
						<div class="zzxue tac mCf" v-if="true">正在学</div>
						<div class="jietitle">第1节</div>
						<div class="font28 title">13.1 与三角形有关的线段</div>
						<div class="df dianBox">
							<div class="dian guo"></div>
							<div class="dian guo"></div>
							<div class="dian active"></div>
							<div class="dian"></div>
						</div>
						<div class="df-sb">
							<div class="xuefen mCG">学分：5/88</div>
							<div class="df-a miao">
								<img
									style="width: 0.24rem; height: 0.24rem; margin-right: 0.1rem"
									:src="icon4"
									alt=""
								/>
								完成本节共需约1小时
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '人教版-七年级上册',
			icon3: require('../../assets/img/study/icon-3.png'),
			icon4: require('../../assets/img/study/icon-4.png'),
			icon5: require('../../assets/img/study/icon-5.png'),
			listData: [],
			isLoading:false,
		};
	},
	computed: {
		...mapGetters({
			userInfs: 'userCenter/getUserInfs'
		})
	},
	created() {
		this.getbookchapterlist();
		console.log(this.userInfs, 'userInfs');
	},
	methods: {
		getbookchapterlist() {
			this.isLoading = true;
			let apiData = {
				bookid: this.$route.query.bookid
			};
			this.$api.getbookchapterlist(apiData).then((res) => {
				for (let i = 0; i < res.data.length; i++) {
					let elem = res.data[i];
					elem.show = false;
				}
				for (let i = 0; i < res.data.length; i++) {
					let el = res.data[i].children;
					let newD = [];
					for (let j = 0; j < el.length; j++) {
						let $el = el[j].children;
						if ($el?.length > 0) {
							newD.push(...$el);
						} else {
							newD.push(el[j]);
						}
					}
					res.data[i].children = newD;
				}
				this.listData = res.data;
				this.isLoading = false;
			});
		},
		goPage(item, name,index,data) {
			if (this.userInfs.mode == 1 && index != 0 ) {
					if(data[index-1].isstudy == 0){
						this.$notify({
							type: 'warning',
							message: '请先学习上个小节！'
						});
						return
					}
				}
			if (
				name.indexOf('期中测试') != -1 ||
				name.indexOf('期末测试') != -1 ||
				item.name.indexOf('单元检测') != -1
			) {
				this.newFn(item);
			} else {
				this.$router.push({
					path: '/chapter',
					query: {
						title: name,
						bookid: item.book_id,
						id: item.id
					}
				});
			}
			this.$store.commit('common/setWordsList', item);
		},
		gettextBox(item, index) {
			if (this.userInfs.mode == 1) {
				if (index == 0) {
					item.show = !item.show;
					return;
				}
				if (this.listData[index - 1].isstudy == 1) {
					item.show = !item.show;
				} else {
					this.$notify({
						type: 'warning',
						message: '请按顺序闯关！'
					});
				}
			} else {
				item.show = !item.show;
			}
		},
		newFn(item) {
			let _path = '';
			if (item.type == 0) {
				_path = '/textContent';
			}
			if (item.type == 1 || item.type == 3 || item.type == 2) {
				if (item.title == '拼写') {
					for (let i = 0; i < this.menuList.length; i++) {
						if (this.menuList[i].title == '速记') {
							break;
						}
					}
				}
				_path = '/questionContent';
			}

			if (item.name == '课后练兵' || item.name.indexOf('期中测试') != -1 || item.name.indexOf('期末测试') != -1) {
				_path = '/userTest';
			}
			this.$router.push({
				path: _path,
				query: {
					name: item.name,
					id: item.id,
					type: item.type,
					// class: this.$route.query.class,
					courseId: item.book_id,
					chapterid: item.id
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.content-box {
	height: calc(100% - 1.08rem);
	padding: 0.34rem 0.28rem 0 0.28rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	// min-height: 100vh;
	background: #f5faff;
	.loading-box {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 1.28rem;
		z-index: 1000;
		background: #fff;
		font-size: 0.28rem;
	}
	.textBox {
		width: 100%;
		background: #ffffff;
		border-radius: 0.2rem;
		margin-bottom: 0.22rem;
		padding: 0.32rem;
		.zhangList {
			// margin-bottom: 0.24rem;
			.leftBox {
				width: 1.32rem;
				height: 1.06rem;
				// background-color: royalblue;
				margin-right: 0.2rem;
				display: flex;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.zhangInfs {
				flex: 1;
				.zhangName {
					margin-bottom: 0.22rem;
				}
			}
			.RightBox {
				img {
					width: 0.28rem;
					margin-bottom: 0.16rem;
				}
			}
		}
		.contentList {
			.jieitem {
				width: 100%;
				height: 2rem;
				background: #f5faff;
				border-radius: 0.14rem;
				border: 1px solid #dce6e8;
				padding: 0.3rem 0.38rem 0.47rem 0.38rem;
				margin-top: 0.24rem;
				position: relative;
				&.active {
					border-color: #ff7a32;
					.jietitle {
						color: #ff7a32;
					}
					margin-top: 0.8rem;
				}
				.zzxue {
					width: 0.93rem;
					height: 0.46rem;
					background: url('../../assets/img/study/icon-5.png') no-repeat;
					background-size: 100% 100%;
					position: absolute;
					right: 0rem;
					top: -0.55rem;
				}
				.jietitle {
					color: #6d9cd4;
				}
				.dianBox {
					margin-bottom: 0.36rem;
					.dian {
						width: 0.15rem;
						height: 0.15rem;
						// background: #6D9CD4;
						background: #ececec;
						border-radius: 0.02rem;
						margin-right: 0.1rem;
						&.active {
							background-color: #48aa89;
						}
						&.guo {
							background-color: #6b9bdb;
						}
					}
				}
				.title {
					margin: 0.22rem 0 0.16rem 0;
				}
				.miao {
					color: #a8ddd0;
				}
			}
		}
	}
}
</style>
